module.exports = __webpack_public_path__ + "img/logo_sm_dark.ceb02179.svg";